import { put, call } from 'redux-saga/effects';
import { otherExpList, otherExpAdd, otherExpEdit, otherExpUpdate, otherExpDelete } from '../../services/settings/otherExpService';

import * as types from '../../actions';

export function* otherExpListSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(otherExpList, payload);
      yield put({ type: types.OTHER_EXP_LIST_SUCCESS, response })
      
    } catch(error) {
      yield put({ type: types.OTHER_EXP_LIST_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
  }
  }

export function* otherExpAddSaga(payload) {
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(otherExpAdd, payload);
      yield put({ type: types.OTHER_EXP_ADD_SUCCESS, response })
            
    } catch(error) {
      yield put({ type: types.OTHER_EXP_ADD_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* otherExpEditSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(otherExpEdit, payload);
    yield put({ type: types.OTHER_EXP_EDIT_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.OTHER_EXP_EDIT_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* otherExpUpdateSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(otherExpUpdate, payload);
    yield put({ type: types.OTHER_EXP_UPDATE_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.OTHER_EXP_UPDATE_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* otherExpDeleteSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(otherExpDelete, payload);
    yield put({ type: types.OTHER_EXP_DELETE_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.OTHER_EXP_DELETE_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}